import React, { useContext } from 'react';

const OptionsContext = React.createContext({});

export const useOptions = () => useContext(OptionsContext);

export default OptionsContext;
